module.exports = __webpack_public_path__ + "images/js_src_vue/page_price_versions/icon_check_grey-d4936ba9.png";